import { type ObjectValuesUnionType } from '../utils/typing';

export type WinModalAsset = {
  banner: { atlas: string; json: string; image: string; fallback?: string; isLopp?: boolean } | string;
  background: { atlas: string; json: string; image: string; fallback?: string; isLopp?: boolean } | string;
  badge?: { image: string; width: string; top: string; left: string };
};

export type WinModalBetslip = {
  winningsAmount: string;
  betAmount: string;
  odd: string;
  isCancelled: boolean;
  betslipReference: string;
  bonusAmount?: string;
  isBetbuilder?: boolean;
  title?: string;
  betTitle?: string;
  animationType: boolean;
};

// descending priority order, last 0
export const WinModalAnimations = Object.freeze({
  CANCELLED: 0,
  WIN: 1,
  COTE_KILLER: 2,
  MAN_OF_MYMATCH: 3,
  MORTAL_COMBO: 4,
});

export type WinModalAnimation = ObjectValuesUnionType<typeof WinModalAnimations>;
